import store from '@/store';

import mutations from '@/store/auth/auth.mutationlist';

export default {
  canActivate(to, from, router) {
    store.commit(mutations.SET_TOKEN, to.params.token);
    return new Promise((resolve, reject) => {
      if (store.state.auth.token) {
        reject();
        router.push({ name: 'Home' });
      } else {
        resolve();
      }
    });
  },
};




// WEBPACK FOOTER //
// ./src/guards/impersonate.js